const iconsOfActionsList = [
  {
    icon: "edit",
    tooltip: "Editar",
    hasVisibleCondition: (element: any[]): boolean => {
      return element.length === 1;
    },
  },
  {
    icon: "trash",
    tooltip: "Eliminar",
    hasVisibleCondition: (element: any[]): boolean => true,
  },
];

export const settingLocation = {
  searchText: "Buscar ubicación",
  addText: "",
  export: true,
  exportFile: "Ubicaciones de retiro en tienda.xlsx",
  expandable: false,
  checkbox: true,
  filter: false,
  filterDefault: "",
  disabled: false,
  partialField: "",
  iconsOfActions: iconsOfActionsList,
  columns: [
    {
      title: "Entidad",
      name: "entityCode",
      type: "string",
      checkAll: false,
      editable: false,
      value: (element: any) => element.entityCode,
    },
    {
      title: "Cód. Ubicación",
      name: "code",
      type: "string",
      checkAll: false,
      editable: false,
      value: (element: any) => element.code,
    },
    {
      title: "Fecha de creación",
      name: "createdAt",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.createdAt,
    },
    {
      title: "Fecha de Modificación",
      name: "updatedAt",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.updatedAt,
    },
    {
      title: "Zona",
      name: "zone",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.zone,
    },
  ],
};
